import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {withStyles} from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import ArrowBackIcon from 'material-ui-icons/ArrowBack';
import AccountCircle from 'material-ui-icons/AccountCircle';
import Menu, {MenuItem} from 'material-ui/Menu';
import AdminNavigation from '../navigation/index';

const styles = {
	root: {
		width: '100%'
	},
	back: {
		marginLeft: '110px',
		marginRight: '24px',
		width: '24px',
		minWidth: '24px',
		minHeight: '24px',

		border: 'none',
		background: 'rgba(0,0,0,0)'
	},
	flex: {
		marginRight: 'auto',
		outline: 0
	}
};

class AdminAppBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null
		};

		this.handleMenu = this.handleMenu.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleSignOut = this.handleSignOut.bind(this);
	}

	render() {
		const {
			classes, user, handleGoBack, isHomepage
		} = this.props;
		const {anchorEl} = this.state;
		const open = Boolean(anchorEl);

		return (
			<AppBar position="static" className={classes.root}>
				<Toolbar>
					{user && (
						<Button
							color="contrast"
							className={classes.back}
							onClick={handleGoBack}
							disabled={isHomepage}
						>
							<ArrowBackIcon/>
						</Button>)}
					<Typography
						type="title"
						color="inherit"
						noWrap
						className={classes.flex}
						component={Link}
						to="/admin"
					>
						<img src="/assets/logo.svg" alt="Juvora Guide"/>
					</Typography>
					{user && (
						<AdminNavigation privileged={user.privileged}/>
					)}
					{user && (
						<div>
							<IconButton
								aria-owns={open ? 'menu-appbar' : null}
								aria-haspopup="true"
								onClick={this.handleMenu}
								color="contrast"
							>
								<AccountCircle/>
							</IconButton>
							<Menu
								id="menu-appbar"
								anchorEl={anchorEl}
								anchorOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'right'
								}}
								open={open}
								onClose={this.handleClose}
							>
								<MenuItem onClick={this.handleSignOut}>Log out</MenuItem>
							</Menu>
						</div>
					)}
				</Toolbar>
			</AppBar>
		);
	}

	handleMenu(e) {
		this.setState({anchorEl: e.currentTarget});
	}

	handleClose() {
		this.setState({anchorEl: null});
	}

	handleSignOut() {
		this.handleClose();
		this.props.signOut();
	}
}

AdminAppBar.propTypes = {
	classes: PropTypes.object.isRequired,
	isHomepage: PropTypes.bool.isRequired,
	handleGoBack: PropTypes.func.isRequired,
	signOut: PropTypes.func.isRequired,
	user: PropTypes.object
};

export default withStyles(styles)(AdminAppBar);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/app-bar/app-bar.jsx